import React from 'react';
import './ProductManagementSectionContainer.scss';
const SchemeManagementSectionContainer = ({ children, title, subTitle, isViewOnly }) => {
  return (
    <div className="product-container">
      <div>
        <h2>{title}</h2>
      </div>

      <div className={!isViewOnly ? 'animated-section active' : ''}>
        <div className="section-title join">{subTitle}</div>
      </div>
      <div className="product-container-section join">{children}</div>
    </div>
  );
};

export default SchemeManagementSectionContainer;
